import React from 'react';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import HeroSlider from '../components/HeroSlider';
import Services from '../components/Services';
import Story from '../components/Story';
import NewsPreview from '../components/NewsPreview';
import BlogSlider from '../components/BlogSlider';
import CharteSection from '../components/CharteSection';
import Partners from '../components/Partners';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <SEO
        title="ATAA REALTY — Expertise & Évaluation Immobilière au Maroc | RICS & IVS"
        description="Cabinet marocain d'expertise et d'évaluation immobilière, de conseil, d'études et de formation. Aligné aux standards RICS et International Valuation Standards (IVS). Casablanca, Maroc."
        canonical="https://ataarealty.com/"
        keywords="expertise immobilière Maroc, évaluation immobilière, expert immobilier Casablanca, RICS, IVS, MRICS, conseil immobilier, études immobilières, formation immobilière, ATAA Realty"
      />
      <Navbar />
      <HeroSlider />
      <Services />
      <Story />
       <CharteSection /> 
      <NewsPreview />
      
      {/* Slider du Blog (Gris) */}
      <BlogSlider />
      
      {/* Nouvelle section Charte (Blanc) */}
     
      
      {/* Partenaires (Blanc avec bordure) */}
      <Partners />

      <Footer />
    </>
  );
};

export default Home;